export const knowledgeBase = [
  {
    keywords: [
      "date",
      "dates",
      "when",
      "duration",
      "schedule",
      "deadline",
      "important dates",
      "time",
      "camera ready",
      "closure",
      "call for paper",
      "cfp",
    ],
    response: "__DYNAMIC_DATES__",
  },
  {
    keywords: [
      "about",
      "what is",
      "theme",
      "objective",
      "focus",
      "icettacs",
      "introduction",
    ],
    response: `The International Conference on Emerging Trends and Technologies in Applications of Computer Science (ICETTACS 2026) is a premier forum for researchers and professionals. It will be held on July 9–10, 2026, at BIT Mesra – Lalpur Unit, Ranchi.`,
  },
  {
    keywords: ["track", "tracks", "topic", "topics", "domain", "subject"],
    response: `<strong>ICETTACS 2026 features 5 multidisciplinary tracks:</strong><br><br>
        <strong>Track 1:</strong> Cyber Physical Systems, Hardware & Network Innovations<br>
        <strong>Track 2:</strong> Security and Cryptography including Blockchain Technology<br>
        <strong>Track 3:</strong> Intelligent Systems and Business Applications<br>
        <strong>Track 4:</strong> Mathematical Computing, Algorithmic Design and Quantum Computing<br>
        <strong>Track 5:</strong> Sustainable Development goals including Earth Exploration`,
  },
  {
    keywords: [
      "submit",
      "submission",
      "paper",
      "guidelines",
      "submission guidelines",
      "template",
      "format",
      "publish",
      "publication",
      "cmt",
      "springer",
      "lnns",
      "aisc",
    ],
    response: `<strong>Paper Submission Guidelines:</strong><br>
Authors are invited to submit original and unpublished research papers through the <strong>CMT (Conference Management Toolkit)</strong>. Manuscripts must strictly follow the prescribed conference templates (LaTeX or MS Word) and should be submitted in <strong>PDF format</strong>.<br><br>

All accepted and presented papers will be published in the proceedings of <strong>Atlantis Press - Part of Springer Nature</strong>. Selected papers may also be submitted for evaluation in <strong>CPCI (Conference Proceedings Citation Index)</strong>, part of <strong>Clarivate's Web of Science</strong>, subject to acceptance.<br><br>

For inclusion in the proceedings, at least one author must complete full registration and present the paper during the conference.<br><br>

For more information, visit:
<a href="https://www.atlantis-press.com/proceedings/series/aisr/abstracting-and-indexing" target="_blank">
Atlantis Press - Abstracting & Indexing
</a>`,
  },
  {
    keywords: [
      "review",
      "peer review",
      "plagiarism",
      "screening",
      "similarity",
      "ethics",
      "ai content",
    ],
    response: `<strong>Peer Review Process & Ethics:</strong><br>
        The conference follows a double-anonymous peer-review process. <strong>The similarity index must be below 10%</strong> (including AI-generated content screening).<br><br>
        Any violation of ethical principles may result in further action in accordance with Springer's publication policies.`,
  },
  {
    keywords: [
      "organizer",
      "committee",
      "chair",
      "convener",
      "head",
      "patron",
      "who is organizing",
      "indranil",
      "manna",
    ],
    response: `<strong>Organizing Committee:</strong><br>
        • <strong>Patron-in-Chief:</strong> Prof. Indranil Manna (VC, BIT Mesra)<br>
        • <strong>Patron:</strong> Dr. Vijay Kumar Jha<br>
        • <strong>General Chair:</strong> Dr. Abhijit Mustafi<br>
        • <strong>Conveners:</strong> Dr. Devesh Kumar Upadhyay, Dr. Partha Sarathi Bishnu, Dr. Nandan Banerji`,
  },
  {
    keywords: [
      "venue",
      "location",
      "where",
      "institute",
      "host",
      "bit mesra",
      "ranchi",
      "lalpur",
    ],
    response: `The conference will be hosted by the Department of Computer Science at <strong>Birla Institute of Technology (BIT), Mesra - Lalpur Unit, Ranchi</strong> as an offline event.`,
  },
  {
    keywords: ["contact", "email", "phone", "help"],
    response: `For queries, Convener Dr. Devesh Kumar Upadhyay can be contacted at <strong>devesh@bitmesra.ac.in</strong> or Mobile: 8802333408.`,
  },
  {
    keywords: ["hello", "hi", "hey", "greetings"],
    response: `Greetings! I am the ICETTACS 2026 Assistant. How can I help you today? You can ask me about important dates, tracks, paper submission, or the organizing committee.`,
  },
  {
    keywords: ["made", "developers", "built by", "who made this website", "website was built by","made by", "website made by", "developer information", "who built this website", "website", "student committee", "student", "developer", "developer of this website"],
    response: `The ICETTACS 2026 website was designed and is actively managed by students of the BIT Lalpur MCA program (Batch 2025-27), namely: <strong>Anurag Tiwari, Harshit Raj</strong> and <strong>Harshita Prasad.</strong>`,
  },
  {
    keywords: ["k", "ok", "okay", "thank you", "thanks", "thankyou", "thanks orbit", "okays", "nice", "bye", "welcome"],
    response: `Thank you for using Orbit😊 Wish you all the best!`,
  },
];

export const conferenceDates = [
  { label: "Call for Papers Opens", date: new Date("2026-01-15") },
  { label: "Submission Deadline", date: new Date("2026-05-31") },
  { label: "Acceptance Notification", date: new Date("2026-06-15") },
  { label: "Camera Ready Submission", date: new Date("2026-06-21") },
  { label: "Registration Deadline", date: new Date("2026-06-19") },
  { label: "Conference Day 1", date: new Date("2026-07-09") },
  { label: "Conference Day 2", date: new Date("2026-07-10") },
];
